import type { NivelEmbajador, Testimonio } from '@/types';

export const testimonios: Testimonio[] = [
  {
    id: 1,
    nombre: "María González",
    rango: "Líder Networker Bronce",
    contacto: "https://www.instagram.com/octavio.esparza.juarez/",
    texto: "Gracias a Ismerely he recuperado mi energía y ahora ayudo a otros a lograr su libertad financiera. ¡Es una transformación total!"
  },
  {
    id: 2,
    nombre: "Carlos Rodríguez",
    rango: "Líder Networker Bronce",
    contacto: "https://www.instagram.com/octavio.esparza.juarez/",
    texto: "El sistema de alcalinización cambió mi salud, y el plan de compensación cambió mi estilo de vida. La mejor decisión que he tomado."
  },
  {
    id: 3,
    nombre: "Ana Martínez",
    rango: "Líder Networker Bronce",
    contacto: "https://www.instagram.com/octavio.esparza.juarez/",
    texto: "Ser parte de esta comunidad me ha permitido crecer como líder. Los productos son excepcionales y se recomiendan solos."
  },
  {
    id: 4,
    nombre: "Luis Hernández",
    rango: "Líder Networker Bronce",
    contacto: "https://www.instagram.com/octavio.esparza.juarez/",
    texto: "Desde que empecé con Ismerely, mi salud mejoró notablemente. Ahora comparto estos productos con toda mi familia."
  },
  {
    id: 5,
    nombre: "Diana López",
    rango: "Líder Networker Bronce",
    contacto: "https://www.instagram.com/octavio.esparza.juarez/",
    texto: "El plan de compensación es justo y generoso. He logrado ingresos que nunca imaginé mientras ayudo a otros."
  }
];

export const nivelesEmbajador: NivelEmbajador[] = [
  {
    nombre: "LÍDER NETWORKER BRONCE",
    requisitos: [
      "5 Embajadores activos en tu primer nivel",
      "Volumen grupal de 22,000 PVN"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único de $4,500 Pesos en producto"
    ],
    color: "#CD7F32"
  },
  {
    nombre: "LÍDER NETWORKER PLATA",
    requisitos: [
      "30 Embajadores activos hasta el tercer nivel",
      "Volumen grupal de 66,000 PVN (6 frontales)"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único de 10,344 pesos",
      "Embajadores al doble con paquete de 4400 puntos hasta el tercer nivel"
    ],
    color: "#C0C0C0"
  },
  {
    nombre: "LÍDER NETWORKER ORO",
    requisitos: [
      "Contar con 90 embajadores Ismerely hasta el nivel 4",
      "Volumen grupal de 198,000 PVN (6 frontales)"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único por avance de rango de $21,683 pesos"
    ],
    color: "#FFD700"
  },
  {
    nombre: "LÍDER DIAMANTE",
    requisitos: [
      "Contar con 180 embajadores Ismerely hasta el nivel 5",
      "Volumen grupal de 396,000 PVN (6 frontales)"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único por avance de rango de $32,926 pesos o el 10% de financiamiento de AUTO"
    ],
    color: "#B9F2FF"
  },
  {
    nombre: "LÍDER DOBLE DIAMANTE",
    requisitos: [
      "Contar con 360 embajadores Ismerely hasta el nivel 6",
      "Volumen grupal de 792,000 PVN (7 frontales)"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Viaje a Sudamérica para 2 Personas"
    ],
    color: "#83EEFF"
  },
  {
    nombre: "LÍDER TRIPLE DIAMANTE",
    requisitos: [
      "Contar con 540 embajadores Ismerely",
      "Volumen grupal de 1,188,000 PVN (8 frontales)",
      "ROLL OVER 50%"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único de Viaje a Norteamerica para 2 Personas"
    ],
    color: "#00E5EE"
  },
  {
    nombre: "LÍDER CORONA",
    requisitos: [
      "Contar con 1620 embajadores Ismerely",
      "Volumen grupal de 3,564,000 PVN (9 frontales PREMIUM)",
      "ROLL OVER 50%"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único de Viaje a Europa para 2 Personas",
      "Bono Estilo de vida (1% primer generación)"
    ],
    color: "#E91E63"
  },
  {
    nombre: "LÍDER DOBLE CORONA",
    requisitos: [
      "Contar con 3240 embajadores Ismerely",
      "Volumen grupal de 7,128,000 PVN (10 frontales PREMIUM)",
      "ROLL OVER 50%"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único de Viaje a Asia para 2 Personas",
      "Bono Estilo de vida (1% 1 y 2 generación)"
    ],
    color: "#D81B60"
  },
  {
    nombre: "LÍDER TRIPLE CORONA",
    requisitos: [
      "Contar con 4860 embajadores Ismerely",
      "Volumen grupal de 10,692,000 PVN (10 frontales PREMIUM)",
      "ROLL OVER 50%"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único de Viaje a DUBAI para 2 Personas",
      "Bono Estilo de vida (1% 1, 2 y 3 generación)"
    ],
    color: "#C2185B"
  },
  {
    nombre: "SENIOR CHAIRMAN 15",
    requisitos: [
      "Volumen grupal de 21,069,200 PVN (13 frontales VIP)"
    ],
    beneficios: [
      "Pin de alcance de rango",
      "Reconocimiento",
      "Bono único de Camioneta BMW X1 o SIMILAR (último modelo)",
      "Bono Estilo de vida (1% 1, 2, 3 y 4 generación)"
    ],
    color: "#AD1457"
  }
];

export const lineasProducto = [
  { id: 'todos', nombre: 'Ver Todo', color: '#4a7c59' },
  { id: 'FT-ELYM LINE', nombre: 'FT-ELYM LINE', color: '#4a7c59' },
  { id: 'BIENESTAR LINE', nombre: 'BIENESTAR LINE', color: '#7fb285' },
  { id: 'AVANCELY LINE', nombre: 'AVANCELY LINE', color: '#e91e8c' },
  { id: 'VYBES LINE', nombre: 'VYBES LINE', color: '#2d5a3d' }
];

export const videos = {
  inicio: 'https://www.youtube.com/embed/M4cLxzA6MVI',
  embajador: 'https://www.youtube.com/embed/yWQqtKdHnG4'
};

export const informacionPlanCompensacion = `Comisiones:

Ganancias Personales:
  🔹 Venta Directa - 50%

Ganancias por tus Invitados:
  🔹 1er Nivel - 25%
  🔹 2do Nivel - 17%
  🔹 3er Nivel - 10%
  🔹 4to Nivel - 5%
  🔹 5to Nivel - 3%
  🔹 6to Nivel - 1%

¡Gana hasta un 61% por las compras de tu equipo!`;

export const transcripcionVideo = `
Octavio Esparza - Plan de Compensación Ismerely

"Hola, te saluda tu amigo Octavio Esparza, líder fundador de la red volando alto aquí en el estado de Aguascalientes.

El día de hoy te quiero compartir un pequeño video de nuestro plan de negocios, de nuestras formas de ganar que nos ofrece esta compañía de Ismerely.

Te voy a compartir pantalla para ir guiándonos sobre lo que estamos hablando y bueno, primeramente preguntarte: ¿Te has imaginado o has pensado en un negocio inteligente?

Bueno, pues este es el mejor negocio que puedes emprender:
- Un negocio donde tengas baja inversión
- Un negocio donde no tengas riesgos, cero riesgos de perder lo que estás invirtiendo
- Al contrario, lo vas a ir duplicando y triplicando
- Alta rentabilidad, porque es un negocio que a medida de que tú vas trabajándolo, vas creciendo y vas recibiendo ingresos superiores en cada ciclo o en cada periodo o en cada mes

Un negocio donde tengas acompañamiento, es decir, somos un equipo en el cual nos rige la honradez, el estar unidos y apoyándonos constantemente para que tu negocio crezca.

Ismerely quiere decir 'mujer virtuosa' y la filosofía que maneja Ismerely es RENUÉVATE.

¿Qué es esto?
Bueno, pues es la combinación de lo que es la trofología con la nutrición holística.
- La trofología es la correcta combinación de las plantas
- La nutrición holística es la nutrición basada en plantas

Cabe mencionar que los productos son 100% orgánicos con registros de COFEPRIS donde lo avala como un producto 100% orgánico.

Ya afortunadamente tenemos también los permisos por parte de la FDA en Estados Unidos y el producto ya se está distribuyendo a varias partes ya de los Estados Unidos.

El plan de negocios de Ismerely es muy sencillo, no tiene mucha ciencia, es muy fácil de entender, muy fácil de aprender, muy fácil de digerir, muy fácil de explicar. Eso es una parte muy importante que Ismerely tiene en nuestro modelo de negocios.

Todas las personas ganan. Ganas solo por consumir, ganas por recomendar, ganas por formar equipos.

Contamos con 7 formas de ganar:
1. Ganancia directa de productos
2. Bonificación por equipo
3. Bono de rango
4. Bono de generación
5. Bono de liderazgo
6. Pool de producción
7. Viajes e incentivos

¿Te gustaría saber más? ¡Contáctame!
`;
